import React from "react";
import { observer } from "mobx-react";

import LiveViewStore from "@state/stores/offer/live/LiveViewStore";

import { LiveVirtualizedOfferSportItem } from "./LiveVirtualizedOfferSportItem";

export default observer(function LiveVirtualizedOfferSports(props: {
	isScrollRestoreWorking: boolean;
	store: LiveViewStore;
	listHeight: number;
}) {
	return (
		<>
			{props.store.virtualizedLiveSportsList.map((spList, i) => (
				<LiveVirtualizedOfferSportItem
					key={i}
					spList={spList}
					isScrollRestoreWorking={props.isScrollRestoreWorking}
					store={props.store}
					listHeight={props.listHeight}
				/>
			))}
		</>
	);
});
